import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter, useHistory } from 'react-router-dom';
import { Button } from 'core.ui-module_site-components';

const QuickSearch = () => {
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const [search, setSearch] = useState(
    window.location.pathname === '/search' ? searchParams.get('s') : ''
  );

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      history.push(`/search?s=${search}`);
    }
  };

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname === '/search') {
        const effectSearchParams = new URLSearchParams(window.location.search);
        setSearch(effectSearchParams.get('s'));
      }
    });

    return function cleanup() {
      unlisten();
    };
  }, [window.location.href]);

  return (
    <Fragment>
      <div className="control">
        <input
          className="input is-small"
          type="tel"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onBlur={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => handleKeyPress(e)}
        />
      </div>
      <Button
        className="is-primary my-2 ml-2 is-small px-2 "
        handleClick={() => {
          history.push(`/search?s=${search}`);
        }}
      >
        GO
      </Button>
    </Fragment>
  );
};

QuickSearch.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default withRouter(QuickSearch);
